import { Button, Grid, TextField, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { UploadReport, getAllCustomerReport, getPackagesById } from "../../actions/LimsAdminActions";

import { useParams } from "react-router-dom";
import Loader from "../../components/Loader2";
import Loader2 from "../../components/loader";
import { Document, Page, pdfjs } from 'react-pdf';
import './upload.css';
import { width } from "@mui/system";
import Autocomplete from "@material-ui/lab/Autocomplete";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        input: {
            padding: "1px",
        },
        contentHeader: {
            width: "100%",
            padding: "0px 10px 10px 0px",
        },

        text: { color: "black" },
    })
);

declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}
interface Props {
    UploadReport: any;
    getAllCustomerReport: any;
    customerReportList: any;
    loading: boolean;
    getPackagesById:any;
    reportPackageTestData:any;
    bookingLoading:any;


}
const StopsPlace: React.FC<Props> = ({
    UploadReport,
    getAllCustomerReport,
    customerReportList,
    loading,
    getPackagesById,
    reportPackageTestData,
    bookingLoading,


}) => {
    const { id } = useParams<{ id: string }>();
    const { firstP, secondP } = useParams<any>();
    const useP = useParams<any>();
    const classes = useStyles();
    const navigate = useNavigate();
    const [file64, setFile64] = React.useState<any>([]);
    const [fileUpload, setFileUpload] = React.useState<any>([]);
    const [pdfFile, setPdfFile] = React.useState<File | null>(null);
    const [numPages, setNumPages] = useState<number>(0);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedTestCode, setSelectedTestCode] =  React.useState<any>("");
    const [packagesData, setPackagesData] = React.useState<any>([]);
    const toBase64 = (file: File) =>
        new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result?.toString();
                if (result) {
                    const base64 = result.split(",")[1];
                    resolve(base64);
                } else {
                    reject(new Error("File read error"));
                }
            };
        });
    const fileUploadHandler = (e: React.ChangeEvent<{ files: any }>) => {
        setFileUpload(e.target.files);
    };
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const list: any = file64;
        if (fileUpload.length > 0) {
            for (let i = 0; i <= fileUpload.length; i++) {
                toBase64(fileUpload[i]).then((data: any) => {
                    let extention = "." + String(data.split(';')[0].split('/')[1]) || "";
                    let b64 = String(data.split(",")[1]);
                    list.push({ "base64": b64.replace("data:application/pdf;base64,", ""), "ext": extention });
                });
            }
        }
        setFile64(list);
    }, [fileUpload]);


    const uploadFile = async (e: any) => {
        e.preventDefault();

        if (!pdfFile) {
            alert('Please select a PDF file');
            return;
        }

        const formData = new FormData();
        formData.append("booking", firstP || '');
        formData.append("report_type", secondP || '');
        formData.append("report_file", pdfFile);
        formData.append("form_data", String(true));
        formData.append("test_id", selectedTestCode);

        await UploadReport(formData);
        navigate(`/dashboard/la`);
    };

    const resetForm = () => {
        setPdfFile(null);
        setNumPages(0);
        if (fileInputRef.current) {
            fileInputRef.current.value = ' ';
        }
    };

    useEffect(() => {
        setPackagesData([]);
        getAllCustomerReport(`${firstP}`);
        getPackagesById(`?booking_id=${firstP}`);
    }, []);

    useEffect(() => {
        if (reportPackageTestData && firstP) {
          if (reportPackageTestData?.data?.length > 0) {
            const test = reportPackageTestData?.data;
            setPackagesData(test|| []);
          } else {
            setPackagesData([]);
          }
        }
      }, [reportPackageTestData]);
    return (
        <Grid container spacing={2} style={{ marginTop: 70 }}>
            <div className={classes.contentHeader}>
                <h2>UPLOAD CUSTOMER REPORT</h2>
            </div>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    textAlign: "start",
                    fontWeight: "bold",
                    border: "4px solid",
                    background: "#0d5e69",
                    color: "white",
                    padding: "10px",
                    borderRadius: "20px"

                }}
            >
                <div style={{ width: "30%", marginLeft: 8 }}>
                    Template Name:&nbsp;&nbsp;{secondP}
                </div>
                <div style={{ width: "20%", marginLeft: 8 }}>Booking Id:&nbsp;&nbsp;{firstP}</div>
            </div>
            {loading ? (
                <Loader2 />
            ) : (
                <Grid container xs={12}>
                    <form onSubmit={uploadFile} onReset={resetForm} style={{ width: "100%", marginTop: "20px" }}>
                        <Grid container spacing={2}>
                           <Grid item xs={12} sm={6} md={4}>
                           <sup style={{ display: "grid", marginTop: "-18px" }}>
                                    <h6>Select Package Or Test</h6>
                                </sup>
                             {
                                bookingLoading ? <div style={{ display:'flex', justifyContent:"flex-start", gap:"10px"}}><span>Package Selection Loading... </span><div>
                                    <Loader width="20px" height="20px" />
                                    </div> </div> : <Autocomplete
                                id="centre"
                                onChange={(event, newValue) => {
                                     setSelectedTestCode(newValue.id);
                                }}
                               
                                options={packagesData || []}
                                freeSolo
                                blurOnSelect
                                aria-required
                                getOptionLabel={(option: any) =>
                                    `${option.name}`
                                  }                                  
                                disableClearable
                                disableCloseOnSelect
                                renderInput={(params) => (
                                    <TextField
                                    className="input"
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Package"
                                    required
                                    style={{
                                        width: "100%",
                                        
                                    }}
                                   />
                                )}
                                />
                             }
                               
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <sup style={{ display: "grid", marginTop: "-18px" }}>
                                    <h6>Upload Customer Report</h6>
                                </sup>
                                <input
                                    type="file"
                                    accept="application/pdf"
                                    ref={fileInputRef}
                                    onChange={(e) => {
                                        setPdfFile(e.target.files ? e.target.files[0] : null);
                                        setNumPages(0);
                                    }}
                                    required
                                    style={{ border: "3px solid #ccc", height: "40px", width: "100%" }}
                                />
                                {pdfFile && (
                                    <div style={{ marginTop: "20px" }} className="pdf-viewer">
                                        <Document
                                            file={pdfFile}
                                            onLoadSuccess={(info) => setNumPages(info.numPages)}
                                            options={{ workerSrc: '/pdf.worker.js' }}
                                        >
                                            {Array.from(new Array(numPages), (el, index) => (
                                                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                            ))}
                                        </Document>
                                        {/* <TablePagination
                                            rowsPerPageOptions={[]}
                                            count={numPages}
                                            page={0}
                                            onChangePage={() => { }}
                                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                                        /> */}
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Button
                                    style={{ backgroundColor: "#9c27b0", color: "white", marginTop: 6 }}
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                >
                                    Upload
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Button
                                    style={{ backgroundColor: "#ad170c", color: "white", marginTop: 6 }}
                                    variant="contained"
                                    fullWidth
                                    // onClick={() => resethandler()}
                                    type="reset"
                                >
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>

            )}
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    customerReportList: state.LimsAdminReducer.customerReportList,
    loading: state.LimsAdminReducer.loading,
    reportPackageTestData: state.LimsAdminReducer.reportPackageTestData,
    bookingLoading: state.LimsAdminReducer.bookingLoading,
});
export default connect(mapStateToProps, {
    UploadReport,
    getAllCustomerReport,
    getPackagesById,
})(StopsPlace);